import { styled, keyframes } from '@mui/system';
import { Paper, Typography } from '@mui/material';

// Define the riseUp animation
const riseUp = keyframes`
  from {
    transform: translateY(20%);
  }
  to {
    transform: translateY(0);
  }
`;

// Styled Title Typography
export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '1rem',
  color: theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
  },
  [theme.breakpoints.down('xs')]: {
    fontSize: '0.8rem',
  },
}));

// Styled Body Typography
export const StyledBody = styled(Typography)(({ theme }) => ({
  fontSize: '0.9rem',
  color: theme.palette.text.secondary,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.85rem',
  },
  [theme.breakpoints.down('xs')]: {
    fontSize: '0.75rem',
  },
}));

// Image Styling
export const StyledImage = styled('img')(({ theme }) => ({
  height: '100px',
  width: '100px',
  [theme.breakpoints.down('sm')]: {
    height: '60px',
    width: '60px',
  },
  [theme.breakpoints.down('xs')]: {
    height: '40px',
    width: '40px',
  },
}));

// Header Container Styling
export const HeaderContainer = styled('div')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  animation: `${riseUp} 0.8s ease-in forwards`,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

// Heading Typography
export const Heading = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '2rem',
  color: theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    fontSize: '2rem',
  },
  [theme.breakpoints.down('xs')]: {
    fontSize: '1.5rem',
  },
}));

// Heading Image Styling
export const HeadingImage = styled('img')(({ theme }) => ({
  height: '60px',
  marginBottom: '16px',
  [theme.breakpoints.down('sm')]: {
    height: '50px',
  },
  [theme.breakpoints.down('xs')]: {
    height: '40px',
  },
}));

// Highlighted Text Styling
export const HighlightedText = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

// Feature Card Styles
export const FeatureCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: 'center',
  width: '100%',
  maxWidth: '380px',
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
  border: '1px solid lightgray',
  borderRadius: theme.spacing(2),
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-10px)',
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.2)',
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '400px',
    maxHeight: '180px',
    padding: theme.spacing(1),
    fontSize: '0.75rem',
  },
  [theme.breakpoints.down('xs')]: {
    maxWidth: '400px',
    maxHeight: '180px',
    padding: theme.spacing(1),
    fontSize: '0.75rem',
  },
}));

// Cards Container Styles
export const CardsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  padding: theme.spacing(2),
  gap: theme.spacing(5),
  animation: `${riseUp} 0.8s ease-in-out forwards`,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
    gap: theme.spacing(1),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    gap: theme.spacing(1),
  },
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(1),
    gap: theme.spacing(1),
  },
}));
